import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { fetchData, saveData } from '../util/functions';
export const LocationContext = createContext({});

/* =============================================================================
<LocationProvider />
============================================================================= */
export const LocationProvider = ({ children }) => {
  const [location, setLocation] = useState(null);
  useEffect(() => {
    const loadLocation = async () => {
      try {
        const stored = await fetchData('location');

        if (stored) setLocation(stored);
      } catch (err) {
        console.error('LocationProvider: failed to load location', err);
      }
    };
    loadLocation();
  }, [])
  const saveLocation = useCallback(async (loc) => {
     setLocation(loc);
     await saveData('location', loc);
   }, []);
  const resetLocation = async () => {
    setLocation(null);
    await saveData('location', null);
  };
  return (
    <LocationContext.Provider
      value={{
        location,
        saveLocation,
        resetLocation,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = () => useContext(LocationContext);
